import React, { SyntheticEvent, useState } from 'react';

import {
  Box,
  FormControl,
  ListSubheader,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import CloseActionButton from '../../../../components/designe/ActionButtons/CloseActionButton';
import AppLanguageAvatar from '../../../../components/designe/app-entity-avatar/app-language-avatar/AppExerciseAvatar';
import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { ILanguage } from '../../../../types/interfaces/language';
import { useStyles } from './LanguageSelectorShell.styles';

interface ILanguageSelectorShellProps {
  languages: ILanguage[];
  selectedKey: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  className?: string;
}

const LanguageSelectorShell = ({
  languages,
  selectedKey,
  onChange,
  className,
}: ILanguageSelectorShellProps) => {
  const theme = useTheme();
  const { classes, cx } = useStyles(theme);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onCloseMenu = (event: SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setIsMenuOpen(false);
  };

  const renderLanguageRow = (lang: ILanguage) => (
    <Box className={classes.row}>
      <AppLanguageAvatar
        language={lang}
        size={AvatarSize.xs}
        type={AvatarTypes.round}
      />
      <Box component="span" className={classes.rowText}>
        <Box component="span" className={classes.languageCode}>
          {lang.key.toUpperCase()}
        </Box>{' '}
        {lang.title}
      </Box>
    </Box>
  );

  return (
    <FormControl size="small" className={cx(classes.formControl, className)}>
      <Select
        value={selectedKey}
        className={classes.select}
        onChange={onChange}
        open={isMenuOpen}
        onOpen={() => setIsMenuOpen(true)}
        onClose={() => setIsMenuOpen(false)}
        aria-label="Language"
        renderValue={(key) => {
          const lang = languages.find((item) => item.key === key);
          return lang ? renderLanguageRow(lang) : null;
        }}
        MenuProps={{
          disableScrollLock: true,
          keepMounted: true,
        }}>
        <ListSubheader
          sx={{
            display: { xs: 'flex', md: 'none' },
            justifyContent: 'flex-end',
            alignItems: 'center',
            lineHeight: 1,
            py: 0.5,
          }}>
          <Box
            component="span"
            sx={{ display: 'inline-flex' }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}>
            <CloseActionButton onClick={onCloseMenu} />
          </Box>
        </ListSubheader>
        {languages.map((lang) => (
          <MenuItem key={lang.id} value={lang.key} className={classes.menuItem}>
            {renderLanguageRow(lang)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelectorShell;
